module.exports = __webpack_public_path__ + "img/stena29.d38cecac.jpg";